<mat-card class="card">
  <mat-card-header class="card-header">
    <mat-card-title>{{ title }}</mat-card-title>
    <mat-card-subtitle *ngIf="subTitle" style="color: white">{{
      subTitle
    }}</mat-card-subtitle>
  </mat-card-header>
  <mat-card-content>
    <ng-content></ng-content>
  </mat-card-content>
</mat-card>
